import { memo } from 'react';
import { Divider, Flex, GoodsCarouselSkeleton } from '@banhala/ui-kit';
import { CodiGoodsCarousel } from './CodiGoodsCarousel';
import { MidRelatedRecommendAdGoodsCarousel } from './MidRelatedRecommendAdGoodsCarousel';
import { useCodiGoodsList } from './queries/useCodiGoodsList';
import { useMidRelatedRecommendGoodsList } from './queries/useMidRelatedRecommendGoodsList';
const CarouselDivider = () => <Divider size={'small'} />;

const CarouselSkeleton = () => (
  <Flex>
    <Flex.Row
      padding={{ horizontal: 16, vertical: 16 }}
      alignItems={'center'}
      justifyContent={'space-between'}
    >
      <Flex
        backgroundColor={'bg_tertiary'}
        width={98}
        height={24}
        borderRadius={4}
      />
      <Flex
        backgroundColor={'bg_tertiary'}
        width={64}
        height={18}
        borderRadius={4}
      />
    </Flex.Row>
    <GoodsCarouselSkeleton count={4} size={'small'} />
  </Flex>
);

export const GoodsCarouselContent = () => {
  const { data: codiGoods, isLoading: loadingCodiGoods } = useCodiGoodsList();
  const { data: midRelatedRecommend, isLoading: loadingMidRelatedRecommend } =
    useMidRelatedRecommendGoodsList();

  const hasCodi = (codiGoods?.codi_goods?.item_list ?? []).length > 0;
  const hasMidAd = (midRelatedRecommend?.item_list ?? []).length > 0;

  if (!loadingCodiGoods && !loadingMidRelatedRecommend && !hasCodi && !hasMidAd)
    return null;

  return (
    <Flex>
      {loadingCodiGoods ? (
        <CarouselSkeleton />
      ) : (
        hasCodi && <CodiGoodsCarousel />
      )}
      {hasCodi && hasMidAd && <CarouselDivider />}
      {loadingMidRelatedRecommend ? (
        <CarouselSkeleton />
      ) : (
        hasMidAd && <MidRelatedRecommendAdGoodsCarousel />
      )}
      {(hasCodi ||
        hasMidAd ||
        loadingCodiGoods ||
        loadingMidRelatedRecommend) && <Divider size={'medium'} />}
    </Flex>
  );
};

export const GoodsCarousel = memo(() => {
  return (
    <Flex>
      <GoodsCarouselContent />
      <CarouselDivider />
    </Flex>
  );
});
